import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CenteredLoader, ZigButton, ZigTypography } from '@ui/index';
import { Box } from '@mui/material';
import { usePaybisRequestStatusQuery } from '../../../../../../apis/user/api';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { PAYBIS_STATUS_CHECK_INTERVAL } from './constants';
import { useNavigate } from 'react-router-dom';
import {
  ROUTE_MAIN_MARKETPLACE,
  ROUTE_MY_BALANCES_TRANSACTIONS,
} from '../../../../../../routes';
import { useCloseAllZModals } from '../../../../../../components/ZModal/use';

// ok bois. Here we're kinda supposed to have 4 statuses
// 1. waiting for deposit to arrive. means !!requestError.
// 2. payment successful, funds not arriveed yet
// 3. payment successful, funds arrived
// 4. expired/rejected/anuthing - not supported kidna.
enum PaybisDepositStatus {
  Waiting,
  PaymentOkDepositWaiting,
  PaymentOkDepositOk,
  Denied,
}

function PaybisRequestStatus({
  requestId,
  reset,
}: {
  requestId: string;
  reset: () => void;
}): React.ReactElement {
  const { t } = useTranslation(['deposit-crypto']);
  const navigate = useNavigate();

  const { data: requestStatus, error: requestError } =
    usePaybisRequestStatusQuery(requestId, {
      skip: !requestId,
      pollingInterval: PAYBIS_STATUS_CHECK_INTERVAL,
    });

  const closeAll = useCloseAllZModals();

  const status = useMemo(() => {
    return PaybisDepositStatus.PaymentOkDepositOk;
    if (requestError) return PaybisDepositStatus.Waiting;
    if (requestStatus) return PaybisDepositStatus.PaymentOkDepositOk;
    if (requestStatus) return PaybisDepositStatus.PaymentOkDepositWaiting;
    return null;
  }, [requestStatus, requestError]);

  return (
    <Box sx={{ textAlign: 'center', m: 2 }}>
      {status === PaybisDepositStatus.Waiting && (
        <>
          <ZigTypography component={'p'} sx={{ textAlign: 'center' }}>
            {t('buy-crypto-modal.waiting-for-status')}
          </ZigTypography>
          <CenteredLoader sx={{ py: 2, mt: 3, mb: 4 }} />
          <ZigButton
            variant={'outlined'}
            onClick={reset}
            startIcon={<HighlightOffIcon color={'secondary'} />}
          >
            {t('buy-crypto-modal.cancel-request')}
          </ZigButton>
        </>
      )}

      {status === PaybisDepositStatus.PaymentOkDepositWaiting && (
        <>
          <ZigTypography component={'p'} sx={{ textAlign: 'center' }}>
            {t('buy-crypto-modal.payment-ok-deposit-nok')}
          </ZigTypography>
          <CenteredLoader sx={{ py: 2, mt: 3, mb: 4 }} />
        </>
      )}

      {status === PaybisDepositStatus.PaymentOkDepositOk && (
        <>
          <ZigTypography component={'p'} sx={{ textAlign: 'center' }}>
            {t('buy-crypto-modal.payment-ok-deposit-nok')}
          </ZigTypography>

          <ZigButton
            size='large'
            sx={{ mx: 2 }}
            variant={'contained'}
            onClick={() => {
              navigate(ROUTE_MAIN_MARKETPLACE);
              closeAll();
            }}
          >
            {t('buy-crypto-modal.post-buy-cta-balances')}
          </ZigButton>
          <ZigButton
            size='large'
            sx={{ mx: 2 }}
            variant={'outlined'}
            onClick={() => {
              navigate(ROUTE_MY_BALANCES_TRANSACTIONS);
              closeAll();
            }}
          >
            {t('buy-crypto-modal.post-buy-mental-balances')}
          </ZigButton>
        </>
      )}
    </Box>
  );
}

export default PaybisRequestStatus;
